// Admin API client — /admin/product-emails/* (mirrors the API's product-emails aggregate).

import type {
  ProductEmailSend,
  ProductEmailDraftRequest,
  ProductEmailSendTestRequest,
  ProductEmailPreviewRequest,
  ProductEmailRecipientMode,
} from '@a7y/types';
import { client } from './transport';

export const productEmailsApi = {
  // Product Emails
  previewProductEmail: (data: ProductEmailPreviewRequest) =>
    client.post<{ html: string }>('/product-emails/preview', data),
  saveDraft: (data: ProductEmailDraftRequest & { id?: string }) =>
    client.post<{ draft: ProductEmailSend }>('/product-emails/drafts', data),
  listDrafts: () => client.get<{ drafts: ProductEmailSend[] }>('/product-emails/drafts'),
  getDraft: (id: string) => client.get<{ draft: ProductEmailSend }>(`/product-emails/drafts/${id}`),
  deleteDraft: (id: string) => client.delete<{ message: string }>(`/product-emails/drafts/${id}`),
  sendTestEmail: (data: ProductEmailSendTestRequest) =>
    client.post<{ send: ProductEmailSend }>('/product-emails/send-test', data),
  executeSend: (draftId: string) =>
    client.post<{ send: ProductEmailSend }>('/product-emails/send', { draftId }),
  listSends: (params?: { limit?: number }) => {
    const searchParams = new URLSearchParams();
    if (params?.limit) searchParams.set('limit', String(params.limit));
    return client.get<{ sends: ProductEmailSend[] }>(`/product-emails/sends?${searchParams}`);
  },
  getSendDetail: (id: string) =>
    client.get<{ send: ProductEmailSend }>(`/product-emails/sends/${id}`),
  getRecipientCount: (mode: ProductEmailRecipientMode) => {
    const searchParams = new URLSearchParams({ mode });
    return client.get<{ count: number }>(`/product-emails/recipients/count?${searchParams}`);
  },
};
